// various colour palettes to map the 128 color antic display to RGB
// WikiNTSC and (very similar) Atari800MacXnewStellaNTSC seem to work well in practice
function rgbs(strs: TemplateStringsArray): string[] {
    const rgbs = strs[0].trim().split(/\s+/).map(s => '#'+s);
    if (rgbs.length == 128) {
        return rgbs;
    } else if (rgbs.length == 256) {
        return rgbs.filter((_, i) => i % 2 == 0)
    } else {
        throw new Error("rgbs: Expected 128 or 256 rgb triples");
    }
}

// from .act dump via: xxd -c24 -g3 Atari\ 128\ \(NTSC\).act | cut -c11-65 | head -16
// 128 colors indexed via high 7 bits, e.g. 0x00 and 0x01 refer to the first entry
const colorPalettes = {
    // See Antic NTSC palette via https://en.wikipedia.org/wiki/List_of_video_game_console_palettes#NTSC
    WikiNTSC: rgbs`
000000 404040 6c6c6c 909090 b0b0b0 c8c8c8 dcdcdc ececec
444400 646410 848424 a0a034 b8b840 d0d050 e8e85c fcfc68
702800 844414 985c28 ac783c bc8c4c cca05c dcb468 ecc878
841800 983418 ac5030 c06848 d0805c e09470 eca880 fcbc94
880000 9c2020 b03c3c c05858 d07070 e08888 eca0a0 fcb4b4
78005c 8c2074 a03c88 b0589c c070b0 d084c0 dc9cd0 ecb0e0
480078 602090 783ca4 8c58b8 a070cc b484dc c49cec d4b0fc
140084 302098 4c3cac 6858c0 7c70d0 9488e0 a8a0ec bcb4fc
000088 1c209c 3840b0 505cc0 6874d0 7c8ce0 90a4ec a4b8fc
00187c 1c3890 3854a8 5070bc 6888cc 7c9cdc 90b4ec a4c8fc
002c5c 1c4c78 386890 5084ac 689cc0 7cb4d4 90cce8 a4e0fc
003c2c 1c5c48 387c64 509c80 68b494 7cd0ac 90e4c0 a4fcd4
003c00 205c20 407c40 5c9c5c 74b474 8cd08c a4e4a4 b8fcb8
143800 345c1c 507c38 6c9850 84b468 9ccc7c b4e490 c8fca4
2c3000 4c501c 687034 848c4c 9ca864 b4c078 ccd488 e0ec9c
442800 644818 846830 a08444 b89c58 d0b46c e8cc7c fce08c
`,
    // from https://forums.atariage.com/topic/243369-atari-128-color-palettes/
    AltirraNTSC: rgbs`
000000 101010 393939 636363 7b7b7b a5a5a5 c6c6c6 efefef
100000 312100 5a4200 846b00 9c8400 c6ad00 e7d629 fff74a
310000 5a0800 7b2900 a55200 bd6b00 e79429 ffb552 ffde73
4a0000 6b0000 941000 bd3929 d65242 ff7b6b ffa594 ffc6b5
4a0000 730029 94004a bd2973 d64294 ff6bb5 ff94de ffb5ff
39004a 630073 8c0094 ad21bd ce42d6 ef63ff ff8cff ffb5ff
21007b 4200a5 6b00c6 9429ef ad42ff d66bff f794ff ffb5ff
000094 2100bd 4210de 6b39ff 8452ff ad7bff ce9cff f7c6ff
00008c 0000b5 1829d6 4252ff 5a6bff 8494ff a5b5ff cedeff
000063 00218c 0042ad 186bd6 3984f7 5aadff 84ceff adf7ff
001021 00394a 005a73 008494 219cb5 4ac6de 6be7ff 94ffff
002100 004a00 006b21 00944a 18ad6b 42d68c 63f7b5 8cffde
002900 004a00 007300 109c08 29b521 52de4a 73ff6b 9cff94
002100 004a00 006b00 299400 42ad00 6bd610 94ff39 b5ff5a
001000 083900 296300 528400 6ba500 94c600 b5ef18 deff42
080000 312100 524a00 7b6b00 948c00 bdb500 e7d621 ffff4a
`,
    AltirraPAL: rgbs`
000000 212121 4a4a4a 6b6b6b 848484 a5a5a5 cecece efefef
420000 631800 843900 ad5a08 c67321 e79c42 ffbd63 ffde8c
520000 730800 942918 bd4a39 d66352 f78c7b ffad9c ffcebd
520000 7b0029 9c184a bd426b d65a84 ff7bad ff9cce ffc6ef
520031 73005a 94107b bd399c d652b5 f773de ff94ff ffbdff
39006b 63008c 8410ad a539d6 bd52ef e773ff ff94ff ffbdff
21008c 4200ad 6318ce 8c42f7 a55aff c67bff e79cff ffc6ff
00008c 0018ad 2139ce 4a63f7 637bff 849cff a5bdff cee7ff
000863 00318c 0852ad 2973ce 4294e7 6bb5ff 8cd6ff adffff
002131 004252 006373 188c9c 31a5b5 5ac6d6 7be7f7 9cffff
002900 005221 007342 18946b 31ad84 52d6a5 73f7c6 9cffef
003100 005a00 087b00 319c00 4ab518 6bde42 8cff63 b5ff84
002900 005200 297300 4a9400 63ad00 8cd621 adf742 ceff63
001800 294200 4a6300 6b8400 849c00 adc610 cee731 efff5a
210800 4a2900 6b5200 8c7300 a58c00 ceb521 efd642 fff763
420000 631800 843900 ad5a08 c67321 e79c42 ffbd63 ffde8c
`,
    // 256 color palettes from Atari800MacX
    Atari800MacXreal: rgbs`
323132 3f3e3f 4d4c4d 5b5b5b 6a696a 797879 888788 979797
a1a0a1 afafaf bebebe cecdce dbdbdb ebeaeb fafafa ffffff
612e00 6c3b00 7a4a00 885800 94670c a5761b b2842a c1943a
ca9d43 daad53 e8bb62 f8cb72 ffd87f ffe88f fff79f ffffae
6c2400 773000 844003 924e11 9e5d22 af6c31 bc7b41 cc8a50
d5935b e4a369 f2b179 ffc289 ffcf97 ffdfa6 ffedb5 fffdc4
751618 812324 8f3134 9d4043 aa4e50 b85e60 c66d6f d57d7f
de8787 ed9596 fca4a5 ffb4b5 ffc2c4 ffd1d3 ffe0e1 ffeff0
620e71 6e1b7c 7b2a8a 8a3998 9647a5 a557b5 b365c3 c375d1
cd7eda dc8de9 ea97f7 f9acff ffbaff ffc9ff ffd9ff ffe8ff
560f87 611d90 712c9e 7f3aac 8d48ba 9b58c7 a967d5 b877e5
c280ed d090fc df9fff eeafff fcbdff ffccff ffdbff ffeaff
461695 5122a0 6032ac 6e41bb 7c4fc8 8a5ed6 996de3 a87cf2
b185fb c095ff cfa3ff dfb3ff eec1ff fcd0ff ffdfff ffefff
212994 2d359f 3d44ad 4b53ba 5961c7 686fd5 777ee2 878ef2
9097fa 96a6ff aeb5ff bfc4ff cdd2ff dae3ff eaf1ff fafeff
0f3584 1c418d 2c509b 3a5eaa 486cb7 587bc5 678ad2 7699e2
80a2eb 8fb2f9 9ec0ff add0ff bdddff cbecff dbfcff eaffff
043f70 114b79 215988 2f6896 3e75a4 4d83b2 5c92c1 6ca1d2
74abd9 83bae7 93c9f6 a2d8ff b1e6ff c0f5ff d0ffff deffff
005918 006526 0f7235 1d8144 2c8e50 3b9d60 4aac6f 59bb7e
63c487 72d396 82e2a5 92f1b5 9ffec3 aeffd2 beffe2 cefff1
075c00 146800 227500 328300 3f910b 4fa01b 5eae2a 6ebd3b
77c644 87d553 96e363 a7f373 b3fe80 c3ff8f d3ffa0 e3ffb0
1a5600 286200 367000 457e00 538c00 629b07 70a916 80b926
89c22f 99d13e a8df4d b7ef5c c5fc6b d5ff7b e3ff8b f3ff99
334b00 405700 4d6500 5d7300 6a8200 7a9100 889e0f 98ae1f
a1b728 bac638 bfd548 cee458 dcf266 ebff75 faff85 ffff95
4b3c00 584900 655700 746500 817400 908307 9f9116 aea126
b7aa2e c7ba3e d5c74d e5d75d f2e56b fef47a ffff8b ffff9a
602e00 6d3a00 7a4900 895800 95670a a4761b b2832a c2943a
cb9d44 daac53 e8ba62 f8cb73 ffd77f ffe791 fff69f ffffaf
`,
    Atari800MacXdefault: rgbs`
000000 1c1c1c 393939 595959 797979 929292 ababab bcbcbc
cdcdcd d9d9d9 e6e6e6 ececec f2f2f2 f8f8f8 ffffff ffffff
391701 5e2304 833008 a54716 c85f24 e37820 ff911d ffab1d
ffc51d ffce34 ffd84c ffe651 fff456 fff977 ffff98 ffff98
451904 721e11 9f241e b33a20 c85122 e36920 ff811e ff8c25
ff982c ffae38 ffc545 ffc559 ffc66d ffd587 ffe4a1 ffe4a1
4a1704 7e1a0d b21d17 c82119 df251c ec3b38 fa5255 fc6161
ff706e ff7f7e ff8f8f ff9d9e ffabad ffb9bd ffc7ce ffc7ce
050568 3b136d 712272 8b2a8c a532a6 b938ba cd3ecf db47dd
ea51eb f45ff5 fe6dff fe7afd ff87fb ff95fd ffa4ff ffa4ff
280479 400984 590f90 70249d 8839aa a441c3 c04adc d054ed
e05eff e96dff f27cff f88aff ff98ff fea1ff feabff feabff
35088a 420aad 500cd0 6428d0 7945d0 8d4bd4 a251d9 b058ec
be60ff c56bff cc77ff d183ff d790ff db9dff dfaaff dfaaff
051e81 0626a5 082fca 263dd4 444cde 4f5aee 5a68ff 6575ff
7183ff 8091ff 90a0ff 97a9ff 9fb2ff afbeff c0cbff c0cbff
0c048b 2218a0 382db5 483ec7 584fda 6159ec 6b64ff 7a74ff
8a84ff 918eff 9998ff a5a3ff b1aeff b8b8ff c0c2ff c0c2ff
1d295a 1d3876 1d4892 1c5cac 1c71c6 3286cf 489bd9 4ea8ec
55b6ff 70c7ff 8cd8ff 93dbff 9bdfff afe4ff c3e9ff c3e9ff
2f4302 395202 446103 417a12 3e9421 4a9f2e 57ab3b 5cbd55
61d070 69e27a 72f584 7cfa8d 87ff97 9affa6 adffb6 adffb6
0a4108 0d540a 10680d 137d0f 169212 19a514 1cb917 1ec919
21d91b 47e42d 6ef040 78f74d 83ff5b 9aff7a b2ff9a b2ff9a
04410b 05530e 066611 077714 088817 099b1a 0baf1d 48c41f
86d922 8fe924 99f927 a8fc41 b7ff5b c9ff6e dcff81 dcff81
02350f 073f15 0c4a1c 2d5f1e 4f7420 598324 649228 82a12e
a1b034 a9c13a b2d241 c4d945 d6e149 e4f04e f2ff53 f2ff53
263001 243803 234005 51541b 806931 978135 af993a c2a73e
d5b543 dbc03d e1cb38 e2d836 e3e534 eff258 fbff7d fbff7d
401a02 581f05 702408 8d3a13 ab511f b56427 bf7730 d0853a
e19344 eda04e f9ad58 fcb75c ffc160 ffc671 ffcb83 ffcb83
`,
    Atari800MacXnewStellaNTSC: rgbs`
000000 000000 4a4a4a 4a4a4a 6f6f6f 6f6f6f 8e8e8e 8e8e8e
aaaaaa aaaaaa c0c0c0 c0c0c0 d6d6d6 d6d6d6 ececec ececec
484800 484800 69690f 69690f 86861d 86861d a2a22a a2a22a
bbbb35 bbbb35 d2d240 d2d240 e8e84a e8e84a fcfc54 fcfc54
7c2c00 7c2c00 904811 904811 a26221 a26221 b47a30 b47a30
c3903d c3903d d2a44a d2a44a dfb755 dfb755 ecc860 ecc860
901c00 901c00 a33915 a33915 b55328 b55328 c66c3a c66c3a
d5824a d5824a e39759 e39759 f0aa67 f0aa67 fcbc74 fcbc74
940000 940000 a71a1a a71a1a b83232 b83232 c84848 c84848
d65c5c d65c5c e46f6f e46f6f f08080 f08080 fc9090 fc9090
840064 840064 97197a 97197a a8308f a8308f b846a2 b846a2
c659b3 c659b3 d46cc3 d46cc3 e07cd2 e07cd2 ec8ce0 ec8ce0
500084 500084 68199a 68199a 7d30ad 7d30ad 9246c0 9246c0
a459d0 a459d0 b56ce0 b56ce0 c57cee c57cee d48cfc d48cfc
140090 140090 331aa3 331aa3 4e32b5 4e32b5 6848c6 6848c6
7f5cd5 7f5cd5 956fe3 956fe3 a980f0 a980f0 bc90fc bc90fc
000094 000094 181aa7 181aa7 2d32b8 2d32b8 4248c8 4248c8
545cd6 545cd6 656fe4 656fe4 7580f0 7580f0 8490fc 8490fc
001c88 001c88 183b9d 183b9d 2d57b0 2d57b0 4272c2 4272c2
548ad2 548ad2 65a0e1 65a0e1 75b5ef 75b5ef 84c8fc 84c8fc
003064 003064 185080 185080 2d6d98 2d6d98 4288b0 4288b0
54a0c5 54a0c5 65b7d9 65b7d9 75cceb 75cceb 84e0fc 84e0fc
004030 004030 18624e 18624e 2d8169 2d8169 429e82 429e82
54b899 54b899 65d1ae 65d1ae 75e7c2 75e7c2 84fcd4 84fcd4
004400 004400 1a661a 1a661a 328432 328432 48a048 48a048
5cba5c 5cba5c 6fd26f 6fd26f 80e880 80e880 90fc90 90fc90
143c00 143c00 355f18 355f18 527e2d 527e2d 6e9c42 6e9c42
87b754 87b754 9ed065 9ed065 b4e775 b4e775 c8fc84 c8fc84
303800 303800 505916 505916 6d762b 6d762b 88923e 88923e
a0ab4f a0ab4f b7c25f b7c25f ccd86e ccd86e e0ec7c e0ec7c
482c00 482c00 694d14 694d14 866a26 866a26 a28638 a28638
bb9f47 bb9f47 d2b656 d2b656 e8cc63 e8cc63 fce070 fce070
`,
    Atari800MacXz26NTSC: rgbs`
000000 000000 505050 505050 646464 646464 787878 787878
8c8c8c 8c8c8c a0a0a0 a0a0a0 b4b4b4 b4b4b4 c8c8c8 c8c8c8
445400 445400 586800 586800 6c7c00 6c7c00 809000 809000
94a414 94a414 a8b828 a8b828 bccc3c bccc3c d0e050 d0e050
673900 673900 7b4d00 7b4d00 8f6100 8f6100 a37513 a37513
b78927 b78927 cb9d3b cb9d3b dfb14f dfb14f f3c563 f3c563
7b2504 7b2504 8f3918 8f3918 a34d2c a34d2c b76140 b76140
cb7554 cb7554 df8968 df8968 f39d7c f39d7c ffb190 ffb190
7d122c 7d122c 912640 912640 a53a54 a53a54 b94e68 b94e68
cd627c cd627c e17690 e17690 f58aa4 f58aa4 ff9eb8 ff9eb8
730871 730871 871c85 871c85 9b3099 9b3099 af44ad af44ad
c358c1 c358c1 d76cd5 d76cd5 eb80e9 eb80e9 ff94fd ff94fd
5d0b92 5d0b92 711fa6 711fa6 8533ba 8533ba 9947ce 9947ce
ad5be2 ad5be2 c16ff6 c16ff6 d583ff d583ff e997ff e997ff
401599 401599 5429ad 5429ad 683dc1 683dc1 7c51d5 7c51d5
9065e9 9065e9 a479fd a479fd b88dff b88dff cca1ff cca1ff
252593 252593 3939a7 3939a7 4d4dbb 4d4dbb 6161cf 6161cf
7575e3 7575e3 8989f7 8989f7 9d9dff 9d9dff b1b1ff b1b1ff
0f3480 0f3480 234894 234894 375ca8 375ca8 4b70bc 4b70bc
5f84d0 5f84d0 7398e4 7398e4 87acf8 87acf8 9bc0ff 9bc0ff
04425a 04425a 18566e 18566e 2c6a82 2c6a82 407e96 407e96
5492aa 5492aa 68a6be 68a6be 7cbad2 7cbad2 90cee6 90cee6
044f30 044f30 186344 186344 2c7758 2c7758 408b6c 408b6c
549f80 549f80 68b394 68b394 7cc7a8 7cc7a8 90dbbc 90dbbc
0f550a 0f550a 23691e 23691e 377d32 377d32 4b9146 4b9146
5fa55a 5fa55a 73b96e 73b96e 87cd82 87cd82 9be196 9be196
1f5100 1f5100 336505 336505 477919 477919 5b8d2d 5b8d2d
6fa141 6fa141 83b555 83b555 97c969 97c969 abdd7d abdd7d
344600 344600 485a00 485a00 5c6e14 5c6e14 708228 708228
84963c 84963c 98aa50 98aa50 acbe64 acbe64 c0d278 c0d278
463e00 463e00 5a5205 5a5205 6e6619 6e6619 827a2d 827a2d
968e41 968e41 aaa255 aaa255 beb669 beb669 d2ca7d d2ca7d
`,
    Atari800MacXxformer: rgbs`
000000 202020 404040 606060 7c7c7c 909090 a0a0a0 b0b0b0
bcbcbc c8c8c8 d4d4d4 e0e0e0 e8e8e8 f0f0f0 f8f8f8 fcfcfc
181400 302800 603c04 785008 8c6c0c 9c8418 b0a830 bcb044
c4c050 d0cc5c d8d468 dcdc74 e0e084 e4e490 e8e89c ececa4
241400 382400 503400 705000 907004 ac8404 bc9c28 c4ac44
ccb860 d4bc68 dcc470 e4c878 eccc80 f0d490 f4dc9c f8e0a0
2c0c04 481408 6c1c10 902c20 b05034 b86040 c47054 cc7864
d48c78 d89888 dca894 e0ac98 e4b09c e4b8a0 e8c0a8 ecc4b0
2c040c 581824 942844 a83c58 b45470 c06078 c86880 d07088
d47890 d88498 dc8ca0 e094a8 e49cb0 e8a4b4 eca8b8 f0acbc
30002c 500848 701068 9c2094 c048c4 d460d4 dc74dc e080e0
e48ce4 e894e8 ec9cec eca4ec eca8ec ecacec ecb0ec f0b4f0
140440 280880 5828b8 6c3cc4 8054cc 8c64d0 9870d4 a080d8
a88cdc b094e0 b898e4 bca0e4 c0a4e8 c4ace8 c8b0ec ccb4ec
000034 101068 2828b8 4848c4 6060d4 6c6cd8 7878dc 8484e0
9090e4 9c9ce4 a4a4e8 acace8 b0b0ec b8b8f0 c0c0f4 c4c4f8
041c48 083478 0c4ca8 1060a8 2470b4 3880c0 448ccc 5094d4
609cdc 70a4e0 7cb0e4 88b8e4 94bce8 9cc0e8 a4c4ec a8c8f0
041030 081858 0c2880 143c90 205098 3c64b0 5478bc 6088c4
6c98d0 74a8d8 7cb0dc 84b8e0 90bce4 98c4e8 a0c8ec a8ccf0
00241c 044838 086850 0c8c6c 10a884 18bc98 38ccb0 48d4b8
58dcc4 64e0cc 70e4d0 80e8d4 90ecdc a0f0e0 b0f4e4 b4f8e8
002804 00400c 045814 14841c 24b040 38c054 4ccc60 58d070
60d47c 78dc8c 90e498 9ce8a4 a4ecb0 acecbc b8ecc4 bcf0c8
0c2800 185000 247804 389410 48b01c 58b830 68c044 74c858
84d068 90d870 98dc78 a0e084 a8e490 b4e89c c0eca8 c4f0ac
142400 2c5800 448c04 5ca808 74c020 88c830 98cc44 a0d054
a8d460 b0d86c b8dc74 bce07c c0e488 c8e894 d0eca0 d4f0a8
201c00 4c4000 706010 847c18 c09820 d0b030 dcc83c e4d04c
e8d858 e8e060 ece468 ece874 f0e884 f4ec8c f4ec90 f8f098
201400 342400 583804 80540c a87414 b4841c c09030 c89c48
d4a860 d8b46c dcb878 e0bc84 e4c490 e8c898 e8d49c ecd8a0
`,
};

export {colorPalettes};